<template>
  <div class="z-card price-card">
    <template v-if="!!fullValue">
      <div class="price-card__value">
        {{ fullValue | formatCurrency }}
      </div>
      <div class="price-card__label">
        vencimento em {{ monthName }}
      </div>
    </template>
    <price-card-loader v-else />
  </div>
</template>

<style lang="scss" scoped>

.price-card {
  margin-bottom: var(--space-extra-large);
  margin-top: var(--space-extra-large);
  text-align: center;
}

.price-card__value {
  font-size: rem(33);
  font-weight: bold;
  line-height: rem(40);
}

.price-card__label {
  color: var(--color-neutral-dark-gray);
  font-size: rem(13);
  font-weight: var(--font-weight-bold);
  line-height: rem(20);
  text-transform: uppercase;
}
</style>

<script>
import DateUtils from 'utils/date-utils';
import PriceCardLoader from 'content-loaders/price-card-loader';

export default {
  components: {
    PriceCardLoader,
  },
  props: {
    fullValue: {
      type: Number,
      default: null,
    },
    dueDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    monthName() {
      return DateUtils.getFormattedDate(this.dueDate);
    },
  },
};
</script>
